import { FilterContainer } from 'containers/filterContainer';
import { ReactElement, useEffect, useMemo, useRef, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import {
  RfUiAccordionCustom,
  RfUiButton,
  RfUiModal,
  RfUiMultiselect,
  RfUiSelect,
} from 'renfe-components';
import { createStructuredSelector } from 'reselect';
import {
  getProvinciasCursosCierres,
  getSociedadesCursosCierres,
  removeCursosCierreFilter,
} from 'store/cursos/actions';
import {
  makeSelectProvinciasCursosCierreParsed,
  makeSelectSociedadesCursosCierreParsed,
} from 'store/cursos/selectors';
import { makeSelectFiltros, makeSelectNombreFiltro, makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected, makesSelectFiltrosParse } from 'store/usuarios/selectors';
import { nomPagina } from '../index';
import { arrayToAPI } from 'utils/listUtils';
import { language } from 'utils/literals';
import { deleteSavedPagination } from 'utils/practiceUtils';
import { userProfile } from 'utils/profilesIndex';
import { editarFiltroRequest, eliminarFiltroRequest, guardarFiltroRequest, setFiltroFechaCreacion, setFiltroFechaModificacion, setFiltroId, setFiltroJson, setFiltroNombre, setFiltroNombrePagina } from 'store/usuarios/actions';
import { RouteTypes } from 'consts';
import { useHistory } from 'react-router';
import { getActualTime } from 'utils/dates-validators';

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  sociedades: makeSelectSociedadesCursosCierreParsed(),
  provincias: makeSelectProvinciasCursosCierreParsed(),
  filtro: makeSelectFiltros(),
  filtros: makesSelectFiltrosParse(),
  nombreFiltro: makeSelectNombreFiltro(),
  sociedadesFiltro: makeSelectSociedadesCursosCierreParsed(),
  provinciasFiltro: makeSelectProvinciasCursosCierreParsed(),
} as any);

const iniFilter = {
  sociedades: '',
  provincias: '',
};

export const ReportCoursesClosingFilter = ({
  handleSubmit,
  data,
}): ReactElement => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    profileActive,
    sociedades,
    provincias,
    filtro,
    filtros,
    nombreFiltro,
    sociedadesFiltro,
    provinciasFiltro,
  } = useSelector<any, any>(selectors);

  const [selectedSociedades, setSelectedSociedades]: [any, any] = useState('');
  const [selectedProvincias, setSelectedProvincias]: [any, any] = useState('');

  const [sociedadResetKey, setSociedadResetKey] = useState(0);
  const [provinciaResetKey, setProvinciaResetKey] = useState(0);

  const resetSociedadPending = useRef(true);
  const resetProvinciaPending = useRef(true);

  const hasMultiselectOptions = (options: any): boolean => {
    if (Array.isArray(options)) {
      return options.length > 0;
    }

    if (typeof options === 'string') {
      try {
        const parsedOptions = JSON.parse(options);
        return Array.isArray(parsedOptions) && parsedOptions.length > 0;
      } catch {
        return false;
      }
    }

    return false;
  };

  useEffect(() => {
    if (
      resetSociedadPending.current &&
      hasMultiselectOptions(sociedades)
    ) {
      setSociedadResetKey(k => k + 1);
      resetSociedadPending.current = false;
    }
  }, [sociedades]);

  useEffect(() => {
    if (
      resetProvinciaPending.current &&
      hasMultiselectOptions(provincias)
    ) {
      setProvinciaResetKey(k => k + 1);
      resetProvinciaPending.current = false;
    }
  }, [provincias]);

  const filter: any = useRef(iniFilter);

  const handleSelectedSociedad = (e) => {
    const sociedades = arrayToAPI(e.detail);
    filter.current = { ...filter.current, sociedades, provincias: '' };

    setSelectedSociedades(JSON.stringify(e.detail));

    setSelectedProvincias('[]');

    // Al cambiar Sociedad se van a cargar nuevas Provincias.
    resetProvinciaPending.current = true;

    dispatch(getProvinciasCursosCierres({ sociedades }));
  };

  const handleSelectedProvincia = (e) => {
    const provincias = arrayToAPI(e.detail);
    filter.current = { ...filter.current, provincias };

    setSelectedProvincias(JSON.stringify(e.detail));
  };

  const cleanFilters = () => {
    dispatch(removeCursosCierreFilter());

    setSelectedOptionFilter(false);
    setIsFilterActive(false);
    setOptionsFilter('');

    setSelectedSociedades('[]');
    setSelectedProvincias('[]');

    filter.current = {
      ...iniFilter
    };

    resetSociedadPending.current = true;
    resetProvinciaPending.current = true;

    dispatch(getSociedadesCursosCierres({}));
    dispatch(getProvinciasCursosCierres({}));

    handlerSubmitFilters();
  };

  const handlerSubmitFilters = () => {
    deleteSavedPagination(window.location.pathname);
    handleSubmit(filter.current);
  };

  useEffect(() => {
    if (profileActive) {
      dispatch(getSociedadesCursosCierres({}));
      dispatch(getProvinciasCursosCierres({}));
    }
  }, [profileActive]);

  //Filtro
  const [selectedFiltros]: [any, any] = useState('');
  const [selectedFilterName, setSelectedFilterName] = useState('');
  const [modalCerradoFiltroGuardarType, setModalCerradoFiltroGuardarType] = useState('');
  const [modalCerradoFiltroEliminarType, setModalCerradoFiltroEliminarType] = useState('');
  const [modalCerradoFiltroEditarType, setModalCerradoFiltroEditarType] = useState('');
  const [selectedFilterId, setSelectedFilterId] = useState('');
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [optionsFilter, setOptionsFilter] = useState('');
  const [selectedOptionFilter, setSelectedOptionFilter] = useState(false);

  const filterNameAdd: boolean = useMemo(() => {
    return !!nombreFiltro;
  }, [nombreFiltro]);

  const handleSelectedFiltros = (e: any) => {
    setSelectedOptionFilter(true);
    const filtroSeleccionado = e.detail;
    setSelectedFilterName(filtroSeleccionado.label);
    const filtroId = filtroSeleccionado.label.split(' - ')[0];
    setSelectedFilterId(filtroId);

    const filtroValue = JSON.parse(filtroSeleccionado.value);


    let parsedProvincias: { label: string; value: string; active?: string }[] = [];
    try {
      parsedProvincias = typeof provinciasFiltro === 'string' ? JSON.parse(provinciasFiltro) : provinciasFiltro;
    } catch (error) {
      console.error(error);
    }

    if (!Array.isArray(parsedProvincias)) {
      parsedProvincias = [];
    }

    let updatedProvincias: { label: string; value: string; active: string }[] = [];

    if (Array.isArray(parsedProvincias)) {
      const uniqueProvincias = new Set<string>();
      updatedProvincias = parsedProvincias
        .filter((provincia) => filtroValue.provincias.split(',').includes(provincia.value))
        .filter((provincia) => {
          if (uniqueProvincias.has(provincia.value)) {
            return false;
          } else {
            uniqueProvincias.add(provincia.value);
            return true;
          }
        })
        .map((provincia) => ({
          label: provincia.label,
          value: provincia.value,
          active: 'true',
        }));
    }

    const filtroValueProvincias = filtroValue.provincias.split(',');
    filtroValueProvincias.forEach((provinciaId) => {
      if (!updatedProvincias.some((provincia) => provincia.value === provinciaId)) {
        const provinciaPractica = parsedProvincias.find((provincia) => provincia.value === provinciaId);
        if (provinciaPractica) {
          updatedProvincias.push({
            label: provinciaPractica.label,
            value: provinciaId,
            active: 'true',
          });
        }
      }
    });

    let parsedSociedades: { label: string; value: string; active?: string }[] = [];
    try {
      parsedSociedades = typeof sociedadesFiltro === 'string' ? JSON.parse(sociedadesFiltro) : sociedadesFiltro;
    } catch (error) {
      console.error(error);
    }

    if (!Array.isArray(parsedSociedades)) {
      parsedSociedades = [];
    }

    let updatedSociedades: { label: string; value: string; active: string }[] = [];

    if (Array.isArray(parsedSociedades)) {
      const uniqueSociedades = new Set<string>();
      updatedSociedades = parsedSociedades
        .filter((sociedad) => filtroValue.sociedades.split(',').includes(sociedad.value))
        .filter((sociedad) => {
          if (uniqueSociedades.has(sociedad.value)) {
            return false;
          } else {
            uniqueSociedades.add(sociedad.value);
            return true;
          }
        })
        .map((sociedad) => ({
          label: sociedad.label,
          value: sociedad.value,
          active: 'true',
        }));
    }

    const filtroValueSociedades = filtroValue.sociedades.split(',');
    filtroValueSociedades.forEach((sociedadId) => {
      if (!updatedSociedades.some((sociedad) => sociedad.value === sociedadId)) {
        const sociedadPractica = parsedSociedades.find((sociedad) => sociedad.value === sociedadId);
        if (sociedadPractica) {
          updatedSociedades.push({
            label: sociedadPractica.label,
            value: sociedadId,
            active: 'true',
          });
        }
      }
    });

    const combinedOptions = [
      ...updatedProvincias,
      ...updatedSociedades,
    ];

    setOptionsFilter(JSON.stringify(combinedOptions));
    setIsFilterActive(true);

    filter.current = {
      sociedades: filtroValue.sociedades,
      provincias: filtroValue.provincias,
    };
  };

  const openModalGuardarFiltroCerrado = () => {
    setModalCerradoFiltroGuardarType('empty');
  }

  const closeModalGuardarFiltroCerrado = () => {
    setModalCerradoFiltroGuardarType('');
  };

  const handleClickConfirmFilterButton = () => {
    const filtroDatos = filter.current;
    const nombrePag = nomPagina;
    const pagina = dispatch(setFiltroNombrePagina(nombrePag));
    const filtroJson = dispatch(setFiltroJson(filtroDatos));
    dispatch(guardarFiltroRequest(pagina, filtroJson));
    history.push(RouteTypes.AUDIT);
    history.push(RouteTypes.REPORT_COURSES_CLOSING);
  };

  const handleChangeFiltroNombre = (e: string) => {
    dispatch(setFiltroNombre(e));
  };

  //Editar filtro
  const openModalEditarFiltroCerrado = () => {
    setModalCerradoFiltroEditarType('confirm');
  };

  const closeModalEditarFiltroCerrado = () => {
    setModalCerradoFiltroEditarType('');
  };

  const confirmModalEditarFiltroCerrado = (filterName: string) => {
    handleClickEditarFiltroButton(filterName);
  };

  const handleClickEditarFiltroButton = (filterName: string) => {
    setModalCerradoFiltroEditarType('');

    const filtroDatos = filter.current;
    const filtroIdString = String(selectedFilterId);
    const nombrePag = nomPagina;
    const pagina = dispatch(setFiltroNombrePagina(nombrePag));
    const filtroJson = dispatch(setFiltroJson(filtroDatos));
    const nombreFiltro = filterName.split(' - ')[1];
    const filtroSeleccionado = filtro.find(filtro => filtro.NOMBRE_FILTRO === nombreFiltro);
    const fechaCreacion = filtroSeleccionado.FECHA_CREACION;
    const fechaModificacion = getActualTime();

    dispatch(setFiltroNombre(nombreFiltro));
    dispatch(setFiltroId(filtroIdString));
    dispatch(setFiltroFechaCreacion(fechaCreacion));
    dispatch(setFiltroFechaModificacion(fechaModificacion));
    dispatch(editarFiltroRequest(filtroJson, pagina));

    history.push(RouteTypes.AUDIT);
    history.push(RouteTypes.REPORT_COURSES_CLOSING);
  }

  //Eliminar filtro
  const openModalEliminarFiltroCerrado = () => {
    setModalCerradoFiltroEliminarType('confirm');
  }

  const closeModalEliminarFiltroCerrado = () => {
    setModalCerradoFiltroEliminarType('');
  }

  const confirmModalEliminarFiltroCerrado = () => {
    handleClickEliminarFiltroButton();
  };

  const handleClickEliminarFiltroButton = () => {
    setModalCerradoFiltroEliminarType('confirm');
    const filtroIdString = String(selectedFilterId);
    dispatch(setFiltroId(filtroIdString));
    dispatch(eliminarFiltroRequest(filtroIdString));
    history.push(RouteTypes.AUDIT);
    history.push(RouteTypes.REPORT_COURSES_CLOSING);
  };

  return (
    <>
      <RfUiAccordionCustom className="rf-accordion">
        <h2 className="rf-title rf-accordion__title">Filtrado</h2>
        <button
          className="rf-accordion__button rf-ui-accordion-custom__button"
          data-toggle="collapse"
          aria-expanded="false"
        >
          Mostrar filtros
        </button>
        <form
          id="courseForm"
          className="rf-accordion__content rf-ui-accordion-custom__panel collapse"
        >
          {(profileActive?.ID_PERFIL === userProfile.administrador || profileActive?.ID_PERFIL === userProfile.supervisor) ? (
            <div className="rf-box">
              <div className="rf-practice-list__input-container">
                <RfUiMultiselect
                  key={`multiselect-sociedades-${sociedadResetKey}`}
                  withoutOptionsText={language.validations.noOptions}
                  textError={language.validations.multiselectEmpty}
                  textLabel="Sociedad"
                  placeholder="Seleccione sociedad"
                  defaultChecks={selectedSociedades}
                  options={sociedades}
                  onOptionSelected={(e: any) => {
                    handleSelectedSociedad(e);
                  }}
                  optionsFilter={optionsFilter}
                  isFilterActive={isFilterActive}
                />
              </div>
            </div>
          ) : null}
          <div className="rf-box">
            <div className="rf-practice-list__input-container">
              <RfUiMultiselect
                key={`multiselect-provincias-${provinciaResetKey}`}
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                textLabel="Provincia"
                placeholder="Seleccione provincia"
                defaultChecks={selectedProvincias}
                options={data && data.length >= 0 ? provincias : ''}
                onOptionSelected={(e: any) => {
                  handleSelectedProvincia(e);
                }}
                optionsFilter={optionsFilter}
                isFilterActive={isFilterActive}
              />
            </div>
            <div className="rf-practice-list__input-container">
              <RfUiSelect
                withoutOptionsText={language.validations.noOptions}
                textError={language.validations.multiselectEmpty}
                options={filtros}
                defaultChecked={selectedFiltros}
                label="Filtros"
                onOptionActive={handleSelectedFiltros}
                placeholder="Seleccione Filtro"
                optionFilter={selectedOptionFilter}
                onEdit={openModalEditarFiltroCerrado}
                onDelete={openModalEliminarFiltroCerrado}
              />
            </div>
          </div>
          <div
            className={`rf-flex rf-justify-end rf-align-center rf-text-align-right
             ${isMobileOnly
                ? 'rf-block--mobile rf-text-align-center--mobile'
                : ''
              }`}
          >
            <RfUiButton
              text="Guardar filtros"
              text-help="Guardar filtros"
              aspect="secondary"
              onButtonClick={() => {
                openModalGuardarFiltroCerrado();
              }}
            >
              {' '}
            </RfUiButton>
            <RfUiButton
              text="Limpiar filtros"
              text-help="Limpiar filtros"
              aspect="secondary"
              onButtonClick={() => {
                cleanFilters();
              }}
            >
              {' '}
            </RfUiButton>
            <RfUiButton
              text="Filtrar"
              type="button"
              aspect="primary"
              className="rf-button rf-margin-left-30"
              onButtonClick={() => {
                handlerSubmitFilters();
              }}
            >
              {' '}
            </RfUiButton>
          </div>
        </form>
        <div>
          <RfUiModal
            title-Modal={'Nombre filtro'}
            id-modal="empty"
            modal-type={modalCerradoFiltroGuardarType}
            slot-content={true}
            onModalClose={(e: any) => {
              closeModalGuardarFiltroCerrado();
            }}
            onConfirm={() => {
              handleClickConfirmFilterButton();
            }}
          >
            <div slot="content">
              <FilterContainer
                title={language.filter.filterName}
                valueFilter={nombreFiltro}
                handleFilterChange={handleChangeFiltroNombre}
              />
            </div>
            <div slot="content">
              <RfUiButton
                disabled={!filterNameAdd}
                text={language.filter.sendConfirm}
                type="button"
                aspect="white"
                className="rf-button"
                onButtonClick={handleClickConfirmFilterButton}
              >
              </RfUiButton>
            </div>
          </RfUiModal>
        </div>
        <div>
          <RfUiModal
            title-Modal={`Usted va a editar el filtro: ${selectedFilterName}`}
            id-modal="moralEdit"
            modal-type={modalCerradoFiltroEditarType}
            required-slot={false}
            onModalClose={() => {
              closeModalEditarFiltroCerrado();
            }}
            onConfirm={() => {
              confirmModalEditarFiltroCerrado(selectedFilterName);
            }}
          >
          </RfUiModal>
        </div>
        <div>
          <RfUiModal
            title-Modal={`¿Esta seguro de que quiere eliminar el filtro? ${selectedFilterName}`}
            id-modal="modalDelete"
            modal-type={modalCerradoFiltroEliminarType}
            required-slot={true}
            onModalClose={(e: any) => {
              closeModalEliminarFiltroCerrado();
            }}
            onConfirm={() => {
              confirmModalEliminarFiltroCerrado();
            }}
          >
          </RfUiModal>
        </div>
      </RfUiAccordionCustom>
    </>
  );
};
